export const sortArray = (arr: any[]): any[] => {
  return arr.sort((a, b) => {
    // If both are numbers, compare them numerically
    if (typeof a === 'number' && typeof b === 'number') {
      return a - b;
    }

    // If both are strings, compare them lexicographically
    if (typeof a === 'string' && typeof b === 'string') {
      return a.localeCompare(b);
    }

    if(a.name && b.name) {

      if (typeof a.name === 'number' && typeof b.name === 'number') {
        return a.name - b.name;
      }
  
      // If both are strings, compare them lexicographically
      if (typeof a.name === 'string' && typeof b.name === 'string') {
        return a.name.localeCompare(b.name);
      }
    }

    // If types differ, convert them to strings and compare
    return String(a).localeCompare(String(b));
  });
}